import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { BackgroundVariant, useBackground } from '../../../background';
import { Header } from '../../atoms/header/header';
import { AnimatedIllustration, AnimatedIllustrationName } from '../../atoms/illustration/animated-illustration';
import { Text } from '../../atoms/text/text';

type IllustrationTypes = {
  bgVariant: BackgroundVariant;
  image: AnimatedIllustrationName;
};

const womanWaitingIllustration: IllustrationTypes = {
  bgVariant: 'indigoPurple',
  image: 'WomanWaitingAnimated',
};

const closedStoreIllustration: IllustrationTypes = {
  bgVariant: 'purpleGreen',
  image: 'ClosedStoreAnimated',
};

const illustrationMap: Record<ErrorType, IllustrationTypes> = {
  ReferralPending: womanWaitingIllustration,
  InviteExpired: closedStoreIllustration,
  ReferralCancelled: closedStoreIllustration,
  InviteNotFound: closedStoreIllustration,
};

type ErrorType = 'ReferralCancelled' | 'InviteExpired' | 'ReferralPending' | 'InviteNotFound';

function ReportError({ error }: { readonly error: ErrorType }) {
  const { t } = useTranslation();
  const { setBackground, resetBackground } = useBackground();
  const { bgVariant, image } = illustrationMap[error];

  useEffect(() => {
    setBackground({ visible: true, variant: bgVariant });
    return () => resetBackground();
  }, [bgVariant, setBackground, resetBackground]);

  return (
    <div className="relative flex">
      <div className="flex flex-col justify-start items-start max-w-[30vw] pt-[20vh] ml-[30vh] z-2">
        <Header level="h1">{t(`page.report.errors.${error}.title`)}</Header>
        <Text size="lg" tag="p">
          {t(`page.report.errors.${error}.subtitle`)}
        </Text>
      </div>
      <AnimatedIllustration className="absolute right-0 pr-[40vh] pt-[10vh] h-[80vh] w-auto z-1" name={image} />
    </div>
  );
}

export { ReportError };
